import React from 'react'
import { useNavigate } from 'react-router-dom'

const ApplyAccount = ({ open }) => {
  const navi = useNavigate()
  if (open) {
    document.querySelector('.application_sheet').scrollTop = 0
  }
  return (
    <div className="ApplyAccount">
      <div className={open ? 'open success_popup notice_popup' : 'success_popup notice_popup'}>
        <div className="logo_brg"></div>
        <p>
          출금계좌변경 <br /> 완료되었습니다!
        </p>
        <div className="logo_success"></div>
        <div>
          <button type="button" className="btn_default" onClick={() => navi('/')}>
            확인
          </button>
        </div>
      </div>
    </div>
  )
}

export { ApplyAccount }
